import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=33b51854&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b51854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b51854')) {
      api.createRecord('33b51854', component.options)
    } else {
      api.reload('33b51854', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=33b51854&scoped=true", function () {
      api.rerender('33b51854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/baseConfig/costConfig/edit.vue"
export default component.exports